<div class="slider" *ngIf="loading">
  <div class="line"></div>
  <div class="subline inc"></div>
  <div class="subline dec"></div>
</div>